import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "appointment-calendar-skeleton",
      attrs: { "data-qa": "appointment_calendar_skeleton" },
    },
    [
      _c(VSkeletonLoader, {
        staticClass: "appointment-calendar-skeleton_collapsed",
        attrs: {
          "data-qa": "appointment_calendar_skeleton_collapsed",
          type: "text",
        },
      }),
      _vm._v(" "),
      !_vm.isCollapsed
        ? _c(
            "div",
            {
              staticClass: "appointment-calendar-skeleton_expanded",
              attrs: { "data-qa": "appointment_calendar_skeleton_expanded" },
            },
            [
              _vm.isMobile
                ? [
                    _c(VSkeletonLoader, {
                      staticClass:
                        "appointment-calendar-skeleton__day-selector",
                      attrs: { type: "button,text,button" },
                    }),
                    _vm._v(" "),
                    _c(VSkeletonLoader, {
                      staticClass: "appointment-calendar-skeleton__slots",
                      attrs: { type: "button@8" },
                    }),
                  ]
                : _c(VSkeletonLoader, {
                    staticClass:
                      "appointment-calendar-skeleton__desktop-calendar",
                    attrs: { type: "text" },
                  }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }